import { createContext } from "react";

export const UserContext = createContext(null);

// the server gives users without a photo a placeholder, treated here as no photo
export const profilePhoto = (photo) => photo && !photo.includes('Default_User') ? photo : null;
